import {
	API_GET_TRANSLATIONS_FILE,API_POST_TRANSLATIONS_FILE
} from 'actions/translations';

export function getTranslationsFile(trad) {
	return {
		type: API_GET_TRANSLATIONS_FILE,
		payload: {
			request: {
				url: `/translations`,
				method: 'POST',
				data: trad,
			},
		},
	};
}

export function getTranslationsFileCsvToJson(json) {
	return {
		type: API_POST_TRANSLATIONS_FILE,
		payload: {
			request: {
				url: `/translations/csvToJson`,
				method: 'POST',
				data: json,
			},
		},
	};
}